import React from 'react';
import { forNamespace, forTemplate } from 'app/common/lib/util/i18n';
import { AddCover, SelectCover } from 'app/src/components/CardCoverChooser';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import { featureFlagClient } from '@trello/feature-flag-client';

const PopOver = require('app/scripts/views/lib/pop-over');
const format = forNamespace('view title');
const formatCardCoverChooser = forTemplate('card_cover_chooser');

export const toggleCardCoverChooserPopover = ({
  elem,
  cardId,
}: {
  elem: Element;
  cardId: string;
}) => {
  const colorAndFullCoversEnabled = featureFlagClient.get(
    'remarkable.rmk-239',
    false,
  );

  const addCover = (
    <ComponentWrapper key="add-cover">
      <AddCover
        cardId={cardId}
        navigateToSelectCover={() => PopOver.popView()}
      />
    </ComponentWrapper>
  );

  const navigateToAddCover = () => {
    PopOver.pushView({
      getViewTitle: () =>
        colorAndFullCoversEnabled
          ? formatCardCoverChooser('photo-search')
          : format('add-cover'),
      reactElement: addCover,
      displayType: 'mod-card-cover-chooser',
    });
  };

  const selectCover = (
    <ComponentWrapper key="select-cover">
      <SelectCover
        {...{
          cardId,
          navigateToAddCover,
        }}
      />
    </ComponentWrapper>
  );

  PopOver.toggle({
    elem,
    getViewTitle: () => format('cover'),
    reactElement: selectCover,
  });
};
